'use client'

import { useEffect, useState } from 'react'
import { listContent, type ListParams } from '@/lib/api'
import type { ContentItem } from '@/lib/types'
import { MovieRow } from '@/components/ui/MovieRow'

interface CatalogRowProps {
  title: string
  icon?: string
  params: ListParams
  seeAllHref?: string
}

/** A discovery row that loads its own data and fails independently. */
export function CatalogRow({ title, icon, params, seeAllHref }: CatalogRowProps) {
  const [items, setItems] = useState<ContentItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let alive = true
    setLoading(true)
    setError(false)
    listContent(params)
      .then((res) => {
        if (alive) setItems(res)
      })
      .catch((e) => {
        console.error('[CatalogRow]', title, e)
        if (alive) setError(true)
      })
      .finally(() => {
        if (alive) setLoading(false)
      })
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <MovieRow
      title={title}
      icon={icon}
      items={items}
      loading={loading}
      error={error}
      seeAllHref={seeAllHref}
    />
  )
}
